import { IButtonStyles, IContextualMenuProps } from '@fluentui/react';
import { IPIconButton } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';

export interface ICopilotChatInputAction {
  key: string;
  iconName: string;
  disabled?: boolean;
  iconColor?: string;
  menuProps?: IContextualMenuProps;
  onClick?: () => void;
  size?: 'small' | 'default';
  title: string;
}

interface ICopilotChatInputActionsProps {
  actions: ICopilotChatInputAction[];
  primaryAction: ICopilotChatInputAction;
  backgroundColor: string;
}

const getButtonStyles = (
  backgroundColor: string,
  size: ICopilotChatInputAction['size'],
  iconColor: string | undefined,
): IButtonStyles => {
  const buttonSize = size === 'small' ? 24 : 30;
  const iconSize = size === 'small' ? 14 : 20;

  return {
    root: {
      width: buttonSize,
      height: buttonSize,
      minWidth: buttonSize,
      minHeight: buttonSize,
      padding: 0,
      background: backgroundColor,
      textDecoration: 'none',
    },
    rootHovered: {
      background: backgroundColor,
      textDecoration: 'none',
    },
    icon: {
      color: iconColor,
      fontSize: iconSize,
      lineHeight: iconSize,
      height: iconSize,
      width: iconSize,
      margin: 0,
    },
  };
};

export const CopilotChatInputActions = (props: ICopilotChatInputActionsProps) => {
  const renderAction = (action: ICopilotChatInputAction) => {
    return (
      <IPIconButton
        key={action.key}
        styles={getButtonStyles(props.backgroundColor, action.size, action.iconColor)}
        disabled={action.disabled}
        iconProps={{ iconName: action.iconName }}
        menuProps={action.menuProps}
        onRenderMenuIcon={() => null}
        onClick={action.onClick}
        title={action.title}
      />
    );
  };

  return (
    <IPStack horizontal horizontalAlign="space-between" verticalAlign="center" styles={{ root: { width: '100%' } }}>
      <IPStack.Item>
        <IPStack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
          {props.actions.map(renderAction)}
        </IPStack>
      </IPStack.Item>
      <IPStack.Item>{renderAction(props.primaryAction)}</IPStack.Item>
    </IPStack>
  );
};
